export type AppLocale = 'it' | 'en';

const STORAGE_KEY = 'pethernity_locale';

export function getStoredLocale(): AppLocale | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'it' || v === 'en') return v;
  } catch {
    /* private mode */
  }
  return null;
}

export function setStoredLocale(locale: AppLocale): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    /* ignore */
  }
}

export function detectBrowserLocale(): AppLocale {
  const lang = (navigator.language || 'it').toLowerCase();
  if (lang.startsWith('en')) return 'en';
  return 'it';
}

export function resolveInitialLocale(): AppLocale {
  return getStoredLocale() ?? detectBrowserLocale();
}
